export const environment = {
  ENV: 'DEV PWA',
  production: true,
  WEBSERVICES: {
    ONLINE: {
      WEB_SERVICE_URL: 'https://dev-webservices.qx.bai-tech.io',
      SOCKET_URL: 'https://dev-webservices.qx.bai-tech.io',
      AUDIO_URL_PREFIX: 'https://gabriele.no-ip.biz/node-services/qcanter-webservices/audio/',
    },
  },
  WEBSERVICES_MODE: 'ONLINE',
  LOGS: {
    CONSOLE: false,
    ERROR: true,
    STORAGE: false,
    SOCKET: true,
    NETWORK: true,
    PWA: false,
  },
  NEED_TO_FORCE_PLATFORM: false,
  PLATFORM_TO_FORCE: '',
  VERSION_CODE_WEB: 0,
  ASSISTANCE_EMAIL: 'support@bai-tech.io',
  STORAGE_NAME: '__qxpwadb_dev',
};
